import React from "react";
import Icon from "@widgets/Icon";
import { styled } from "@acko-tech/building-blocks.ui.common";
import { useEffect, useRef } from "react";
import { device } from "@utils/screens";
import { useLocationPicker } from "@utils/hooks/useLocationPicker";
import { reverseGeoCode } from "@utils/geo";
import { useDispatch } from "react-redux";
import { updateLoader, fetchConfigFailure } from "@store/slices/config";
import { resolvePath } from "@utils/resolvePath";

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 24px 0;
  width: calc(100%);
  border-bottom: 1px dashed #e7e7f0;
  cursor: pointer;
  margin: 0;
  height: 24px;

  @media ${device.tablet} {
    width: 100%;
    margin: 0;
  }
`;

// const Img = styled.img``;

const Title = styled.div`
    color: var(--Text-Primary-grey600, #121212);
    font-family: "Euclid Circular B";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    margin-left: 12px;
`;

const Loader = styled.div`
  margin: 0;
  font-family: Euclid Circular B;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  margin-left: 10px;
  color: #5b5675;
  margin-bottom: 2px;
`;

const LocationPicker = ({ is_visible, actions }: any) => {
  const dispatch = useDispatch();

  const {
    getCurrentLocation,
    position,
    fetchingLocation,
    geoError,
    // locationFetched,
    // permission,
  } = useLocationPicker();

  useEffect(() => {
    if (fetchingLocation) {
      dispatch(updateLoader(true));
    } else {
      dispatch(updateLoader(false));
    }
    if (!fetchingLocation && !geoError && position.lat && position.lng) {
      getAddressFromPosition(position);
    }
  }, [position, geoError, fetchingLocation]);

  const getAddressFromPosition = async ({ lat, lng }: any) => {
    dispatch(updateLoader(true));
    const response = await reverseGeoCode(lat, lng);
    if (!response.error) {
      dispatch(updateLoader(false));
      const data = {
        mainText: response.mainText,
        secondaryText: response.secondaryText,
        fullAddress: response.address,
        placeId: "",
        postalCode: response.postalCode,
        lat,
        lng,
        city: response.city,
        state: response.state
      }
      actions?.on_location_click?.forEach((eachFunc: any) => {
        eachFunc.funCall({
          payloadData: {
            address: data,
            pincode: response.postalCode
          },
          ...eachFunc.args
        });
      });
      actions?.on_location_success?.forEach((func: any) => {
        func.funCall?.({ ...func.args });
      });
    } else {
      dispatch(fetchConfigFailure("Something went wrong!"));
    }
  };
  const ref = useRef(null);
//   useEffect(() => {
//     import("@lottiefiles/lottie-player");
//   }, []);

  if (!is_visible) return <></>;
  console.log("fetchingLocation", fetchingLocation);
  console.log("getCurrentLocation", getCurrentLocation);
  return (
    <Container
      onClick={!fetchingLocation && getCurrentLocation}
      id="use-current-picker"
    >
      <div>
        {fetchingLocation ? (
          <Icon overrideIsVisible={true} path={"/images/GPS.svg"} />
        ) : (
          <Icon
            overrideIsVisible={true}
            path={"/images/GPS.svg"}
          />
        )}
      </div>
      {fetchingLocation ? (
        <>
          <Loader>Fetching current location</Loader>
          <div>
            <lottie-player
              id="loader"
              ref={ref}
              autoplay
              loop
              mode="normal"
              src={resolvePath("/images/locationLoader.json")}
              style={{ width: "40px", height: "40px", marginLeft: "-8px" }}
            ></lottie-player>
          </div>
        </>
      ) : (
        <Title>Use current location</Title>
      )}
    </Container>
  );
};

export default LocationPicker;
